export const WHATS_NEW_GUIDE = {
  id: "whats-new",
  title: "What's New",
  description:
    "Recent updates, improvements, and fixes to the Insights Platform.",
  icon: "Sparkles",
  version: "1.0.0",
  lastUpdated: "2026-03-22",
  sections: [
    {
      id: "mar-2026",
      title: "March 2026",
      content: [
        {
          type: "paragraph",
          text: "**Platform Overhaul — Performance & Code Quality**",
        },
        {
          type: "steps",
          items: [
            "**Faster load times** — removed unused dependencies and dead code across the entire app",
            "**Consistent UI** — shared Spinner, Modal, Confirm Dialog, and Error Banner components now used across all pages for a uniform look and feel",
            "**Improved styling** — standardised fonts, spacing, colours, and border radii app-wide; eliminated inconsistent inline styles",
            "**Backend refactor** — reorganised the database layer into domain-specific modules for faster API responses and easier maintenance; standardised 153 API handlers with a shared wrapper to eliminate thousands of lines of repeated boilerplate",
            "**Duplicate code removed** — consolidated repeated helper functions into shared utilities",
          ],
        },
        {
          type: "callout",
          variant: "info",
          text: "These changes are under-the-hood improvements. All existing features continue to work exactly as before — just faster and more reliable.",
        },
      ],
    },
  ],
};
